// deductDiamond.js
'use strict';
import mergeMeData from '../action/mergeMeData.js';
import getMeBalance from '../selector/getMeBalance.js';

/**
 * Deduct diamond
 * @kind action
 * @param {number} {price} - price.
 * @return {Promise} Action promise.
 */
const deductDiamond =
  ({ price }) =>
  async (dispatch, getState) => {
    const balance = getMeBalance(getState());
    const hasEnoughBalance = balance >= price;

    if (!hasEnoughBalance) {
      return dispatch({ type: '' });
    }

    return dispatch(
      mergeMeData({
        field: 'balance',
        value: {
          total: balance - price,
        },
      })
    );
  };

export default deductDiamond;
